import { PlayerSignInToWatchPopup as PlayerSignInToWatchPopupComponent } from "/app/libraries/arcana/src/blocks/Popup/Templates/index.ts"

import { useUnit } from 'effector-react'
import { $signInToWatchTranslations } from '~/features/signin-to-watch'

interface PlayerSignInToWatchButtonParams {
  onSubmit: () => void
  smallPlayer?: boolean
  isFullscreen?: boolean
}

export const PlayerSignInToWatchPopup = ({
  onSubmit,
  smallPlayer,
  isFullscreen = true,
}: PlayerSignInToWatchButtonParams) => {
  const signInToWatchTranslations = useUnit($signInToWatchTranslations)

  const handleSubmit = (e: React.MouseEvent) => {
    e.preventDefault()
    e.stopPropagation()
    onSubmit?.()
  }

  return (
    <PlayerSignInToWatchPopupComponent
      title={signInToWatchTranslations.title}
      buttonText={signInToWatchTranslations.signInToWatch}
      onSubmit={handleSubmit}
      smallPlayer={smallPlayer}
      isFullscreen={isFullscreen}
    />
  )
}
